import dayjs from 'dayjs';

import { GENDERS } from '@ratehub/documents/common/stable';


export default {
    applicant: {
        firstName: 'Ratehub',
        lastName: 'AutofillTest',
        gender: GENDERS.MALE,
        dob: dayjs('1990-01-01').toISOString(),
        phone: '6135551234',
        email: 'autofill_life@ratehub.ca',
    },
    jointApplicant: {
        firstName: 'RatehubONJointApplicant',
        lastName: 'AutofillTest',
        gender: GENDERS.FEMALE,
        dob: dayjs().subtract(35, 'years').toISOString(),
        hasConsumedTobacco: true,
    },
    wantsEmailUpdates: false,
};